import React from 'react'
import SideNav from './side-nav'
import { useEntities, useIncludes, useMeta, useExperiences } from '../helpers/selectors'
import cohort from '../../koa-chansey/cohort'

const pageForUrlEntity = (urlEntity, experiences) => {
  const { link, variants = [], variantFlag } = urlEntity.fields ? urlEntity.fields : urlEntity
  const index = cohort({ experiences }, variantFlag, null)
  const page = (index !== null && variants.length > index) || !link ? variants[index || 0] : link

  return page
}

const getTitleAndUrl = (link, includes, homePath, experiences) => {
  // get whole link entity
  const entity = includes[link?.sys?.id ?? '']
  const typeId = entity?.sys?.contentTypeId

  let linkTitle
  let linkUrl

  if (typeId === 'url') {
    // the entity type is URL
    const url = entity?.fields.url
    linkUrl = url ? (url[0] === '/' ? url : `${homePath}/${url}`) : ''

    // dereference page from url taking into account experiences
    const pageLink = pageForUrlEntity(entity, experiences)
    const pageEntity = includes[pageLink?.sys?.id ?? '']
    linkTitle = pageEntity?.fields?.title
  } else if (entity?.fields?.urlRef) {
    // the entity type is LinkListItem with URL reference
    linkTitle = entity?.fields.title

    // dereference url entity from URL field of list item
    const urlEntity = includes[entity.fields.urlRef?.sys?.id]
    const url = urlEntity?.fields.url
    linkUrl = url ? (url[0] === '/' ? url : `${homePath}/${url}`) : ''
  } else {
    // the entity type is LinkListItem with URL string
    linkTitle = entity?.fields.title
    linkUrl = entity?.fields.url
  }

  return { title: linkTitle, url: linkUrl }
}

const GuideNav = ({ linkLists = [], ...props }) => {
  const includes = useIncludes()
  const homePath = useMeta(['breadcrumbs', 'homePath'], '')
  const experiences = useExperiences()
  const linkListEntities = useEntities(linkLists)

  const linkListWithLinks = linkListEntities.map((linkGroup) => ({
    ...linkGroup,
    links: linkGroup.links
      .map((link) => {
        const titleAndUrl = getTitleAndUrl(link, includes, homePath, experiences)
        return {
          text: titleAndUrl.title ?? titleAndUrl.url,
          url: titleAndUrl.url,
        }
      })
      .filter((link) => link.url),
  }))

  return <SideNav {...props} additionalLinks={linkListWithLinks} />
}

export default GuideNav
